import { useState } from "react";
import { LaunchItem } from "types/api/launches/getLaunches.ts";
import {
	LaunchCardBody,
	LaunchCardDate,
	LaunchCardHeading,
	LaunchCardImage,
	LaunchCardImagePlaceholder,
	LaunchCardLink,
	LaunchCardPlaceholderIcon,
	LaunchCardRoot,
	LaunchCardSubtitle
} from "../ProductLaunchesPage.styles.ts";
import {
	formatLaunchDate,
	getLaunchHeading,
	getLaunchSubtitle,
	getSafeUrl
} from "../utils/ProductLaunchesPage.utils.ts";

interface LaunchCardProps {
	launch: LaunchItem;
}

export const LaunchCard = ({ launch }: LaunchCardProps) => {
	const [hasImageError, setHasImageError] = useState(false);

	const heading = getLaunchHeading(launch);
	const subtitle = getLaunchSubtitle(launch);
	const launchDate = formatLaunchDate(launch.eventStartDate);
	const launchUrl = getSafeUrl(launch.filePublicUrl);
	const imageUrl = getSafeUrl(launch.imageUrl);

	return (
		<LaunchCardRoot data-testid="launch-card">
			{imageUrl && !hasImageError ? (
				<LaunchCardImage
					src={imageUrl}
					alt=""
					loading="lazy"
					data-testid="launch-card-image"
					onError={() => setHasImageError(true)}
				/>
			) : (
				<LaunchCardImagePlaceholder data-testid="launch-card-image-placeholder">
					<LaunchCardPlaceholderIcon />
				</LaunchCardImagePlaceholder>
			)}
			<LaunchCardBody>
				<LaunchCardHeading isLink={!!launchUrl}>
					{launchUrl ? (
						<LaunchCardLink
							href={launchUrl}
							target="_blank"
							rel="noopener noreferrer"
						>
							{heading}
						</LaunchCardLink>
					) : (
						heading
					)}
				</LaunchCardHeading>
				{subtitle && <LaunchCardSubtitle data-testid="launch-card-subtitle">{subtitle}</LaunchCardSubtitle>}
				{launchDate && <LaunchCardDate data-testid="launch-card-date">{launchDate}</LaunchCardDate>}
			</LaunchCardBody>
		</LaunchCardRoot>
	);
};
